import Chip from '@/components/chip';
import FlatButton from '@/components/flat-button';
import Text from '@/components/text';
import useDrawer from '@/hooks/use-drawer.hook';
import { Box, Stack, Theme } from '@mui/material';
import { FC } from 'react';
import { createUseStyles } from 'react-jss';
import Select from '../../select';
import { UiOption } from '@/lib/helpers';

interface Props {
  classifierId: string;
  label: string;
  description: string;
  enabled: boolean;
  readonly: boolean;
  name: string;
  options: UiOption[];
  value: string;
  refetch: () => Promise<unknown>;
  onChange: (value: string) => void;
}

const useStyles = createUseStyles((theme: Theme) => ({
  listItem: {
    '&:not(:last-child)': {
      borderBottom: `1px solid ${theme.palette.divider}`,
      marginBottom: 8,
      paddingBottom: 8,
    },
  },
}));

export const Item: FC<Props> = ({
  classifierId,
  label,
  description,
  enabled,
  readonly,
  name,
  options,
  value,
  refetch,
  onChange,
}) => {
  const styles = useStyles();
  const { openDrawer } = useDrawer();
  const handleOpenDrawer = () => {
    openDrawer('classifier', {
      id: classifierId || null,
      onChange: refetch,
    });
  };

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      className={styles.listItem}
    >
      <Box pr={4}>
        <Stack direction="row" alignItems="center" gap={1}>
          <FlatButton color="link" label={label} onClick={handleOpenDrawer} />
          {!enabled && <Chip label="Disabled" size="x-small" />}
        </Stack>
        <Box mt={0.5}>
          <Text size="small" color="grey">
            {description}
          </Text>
        </Box>
      </Box>
      <Box minWidth={250}>
        <Select
          name={name}
          options={options}
          readonly={readonly || !enabled}
          value={value}
          onChange={onChange}
          size="small"
        />
      </Box>
    </Stack>
  );
};
